import React from 'react'

type Props = { children: React.ReactNode }

type State = { hasError: boolean; error: Error | null }

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: any) {
    console.error('Unhandled error:', error, info)
    // Optionally send error to a logging service
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-10 text-center">
          <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
          <p className="text-default-500">{this.state.error?.message}</p>
        </div>
      )
    }
    return this.props.children
  }
}